import { Input, Typography } from 'antd';
import React from 'react';
import { useSettingsStore } from '../hooks/useSettingsStore';

const { TextArea } = Input;
const { Paragraph } = Typography;

type DevListTabProps = {
  listKey: 'devWhiteList' | 'devBlackList';
  description?: string;
};

const DevListTab: React.FC<DevListTabProps> = ({ listKey, description }) => {
  const { lists, setDevList } = useSettingsStore();

  return (
    <div style={{ maxWidth: 640 }}>
      <Paragraph type="secondary">
        {description || 'Enter one wallet address per line. Changes are saved automatically.'}
      </Paragraph>
      <TextArea
        rows={12}
        value={lists[listKey]}
        onChange={(event) => setDevList(listKey, event.target.value)}
        placeholder="wallets"
        style={{ fontFamily: 'monospace' }}
      />
    </div>
  );
};

export default DevListTab;
